module.exports = __webpack_public_path__ + "img/icon-done.770829ba.png";